import styled from '@emotion/styled'
import { Theme } from '@yuno/design-system-web'
import { DialogComponent } from '../../dialog'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

const Time = styled('span')<{ theme?: Theme }>`
  ${({ theme }) => ({ ...theme.typography.xl.bold })}
`

const BoldText = styled('span')<{ theme?: Theme }>`
  ${({ theme }) => ({ ...theme.typography.l.bold })};
`

export const InactiveDialog = ({
  openDialog,
  buttons,
  handleOpenDialog,
  title,
  elapsedTime,
  grace,
  description,
}) => {
  const { t } = useTranslation()

  function convertSecondsToTime(seconds) {
    return moment.utc(seconds * 1000).format('mm:ss')
  }

  return (
    <DialogComponent
      openDialog={openDialog}
      title={<BoldText>{t('inactivityTitle')}</BoldText>}
      buttons={buttons}
      handleOpenDialog={handleOpenDialog}
    >
      <>
        <p>{title}</p>
        <Time>{convertSecondsToTime(elapsedTime)}</Time>
        <p>{description}</p>
      </>
    </DialogComponent>
  )
}
